module.exports = __webpack_public_path__ + "img/avatar-dan-abdinoor.098e83bf.jpg";